import React, { Component } from "react";
import PropTypes from 'prop-types';
import Categories from "./Categories";
import {encodeCookieList, existCookie, setCookie} from "../../services/cookies";


class CookieLaw extends Component {

  constructor(props) {
    super(props);
    const existsCookieAgreed = existCookie('cookie-agreed');
    this.state = {
      showBanner: !existsCookieAgreed,
      showCategories: false,
    };
  }

  getCategories() {
    return [
      {
        id: 'analysis',
        required: false,
        name: this.context.t('Analysis cookies'),
        description: this.context.t('These cookies allow us to analyze and measure how you use the website to improve browsing.'),
      },
      {
        id: 'advertising',
        required: false,
        name: this.context.t('Advertising cookies'),
        description: this.context.t('Advertising companies use these cookies to publish adverts that match your interests.'),
      },
      {
        id: 'personalization',
        required: false,
        name: this.context.t('Personalization cookies'),
        description: this.context.t('These cookies allow us to analyze your user profile and use of the website to give you a personalized experience.'),
      },
      {
        id: 'compulsory',
        required: true,
        name: this.context.t('Compulsory cookies'),
        description: this.context.t('These cookies are essential for the website to work correctly.'),
      },
    ]
  }

  toggleConfigure = () => {
    this.setState({ showCategories: !this.state.showCategories });
  };

  onApply = (categoriesStatus) => {
    const activeCategories = [];
    this.getCategories().forEach((category, index) => {
      const active = categoriesStatus[index];
      if (active) {
        activeCategories.push(category.id);
      }
    });

    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 100);

    if (activeCategories.length) {
      const cookiesString = encodeCookieList(activeCategories);
      setCookie('cookie-agreed-categories', cookiesString, expireDate);
    }

    setCookie('cookie-agreed', '2', expireDate);

    this.toggleConfigure();
    this.setState({  showBanner: false });
  };

  render() {
    if (!this.state.showBanner) {
      return null;
    }

    if (this.state.showCategories) {
      return <Categories onClose={this.toggleConfigure} onApply={this.onApply} categories={this.getCategories()}/>
    }

    return (
      <div className="fixed z-100 bg-white w-full p-5 border-4 border-blue-900 max-w-3xl left-1/2 transform -translate-x-1/2">
        <p>{this.context.t('We use cookies to personalize content and ads, improve your user experience, and to analyze our traffic.')}</p>
        <p>{this.context.t('We also share information about your use of our website with our social media, advertising, and analytics partners.')}</p>
        <p>{this.context.t('Continue if you agree, or read more about our use of cookies here.')}</p>
        <div className="mt-2 -mx-2">
          <button className="border border-blue-900 uppercase py-2 px-4 m-2" onClick={this.toggleConfigure}>
            {this.context.t('Configure')}
          </button>
          <button className="border border-blue-900 uppercase py-2 px-4 m-2"
                  onClick={() => this.props.history.push(`/terms-conditions/${this.props.locale}`)}>
            {this.context.t('More info')}
          </button>
          <button className="border border-blue-900 bg-blue-900 text-white uppercase py-2 px-4 m-2"
                  onClick={() => this.onApply([true, true, true, true])}>
            {this.context.t('Ok, I agree')}
          </button>
        </div>
      </div>
    )
  }
}

CookieLaw.contextTypes = {
  t: PropTypes.func.isRequired,
};

CookieLaw.propTypes = {
  history: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};

export default CookieLaw;

